import { useSelector } from 'react-redux';

import { useGetUserViewCampaigns } from '../../hooks/useGetUserViewCampaigns';
import { useCampaignsToShow } from '../../hooks/useCampaignsToShow';
import { Wrapper } from './StyledComponents';
import { CampaignIcon } from './CampaignIcon.jsx';
import { MoreCampaignsMenu } from './MoreCampaignsMenu.jsx';
import { Grid } from '../../../../assets';

export const UserViewCampaigns = ({ boardSlug }) => {
  const showArchivedCampaignSelector = useSelector(
    state => state.demoData.hasArchivedCampaignSelector,
  );
  const {
    campaigns,
    selectedCampaignUuid,
    setSelectedCampaign,
  } = useGetUserViewCampaigns({ boardSlug });

  const {
    recentCampaigns,
    olderCampaigns,
    wrapperRef,
    olderCampaignsByYear,
  } = useCampaignsToShow({
    campaigns,
    showArchivedCampaignSelector,
  });

  return (
    <Wrapper ref={wrapperRef}>
      <CampaignIcon
        tileImage={Grid}
        onClick={() => {
          setSelectedCampaign({});
        }}
        isSelected={selectedCampaignUuid === null}
        name="Home"
      />

      {recentCampaigns.map(campaign => (
        <CampaignIcon
          {...campaign}
          key={campaign.uuid}
          onClick={() => {
            setSelectedCampaign(campaign);
          }}
          isSelected={campaign.uuid === selectedCampaignUuid}
        />
      ))}
      {olderCampaigns.length > 0 && (
        <MoreCampaignsMenu
          selectedCampaignUuid={selectedCampaignUuid}
          setSelectedCampaign={setSelectedCampaign}
          campaigns={olderCampaigns}
        />
      )}
      {showArchivedCampaignSelector &&
        Object.entries(olderCampaignsByYear).map(([year, campaignsByYear]) => (
          <MoreCampaignsMenu
            key={year}
            selectedCampaignUuid={selectedCampaignUuid}
            setSelectedCampaign={setSelectedCampaign}
            campaigns={campaignsByYear}
            year={year}
          />
        ))}
    </Wrapper>
  );
};
